import en from '../locales/en/en.json';
import pt from '../locales/pt/pt.json';
import it from '../locales/it/it.json';
import es from '../locales/es/es.json';
import fr from '../locales/fr/fr.json';
import validator from 'validator';

const languages = {
    pt,
    en,
    it,
    es,
    fr,
}

function getCurrentLang() {
    try {
        const initialState = JSON.parse(localStorage.getItem('@datadrive:initialState'));
        if (initialState && initialState.languageCode) {
            return initialState.languageCode;
        }
    } catch (error) {
        console.error('Error getting language from localStorage:', error);
    }
    return 'pt';
}

function required(value) {
    const lang = getCurrentLang();
    return !!value || languages[lang].defaultValidations.required;
}

function isEmail(value) {
    return !value || validator.isEmail(value);
}

function maxLength(maxLength) {
    return value => {
        const lang = getCurrentLang();
        return value === '' || (value && value.length <= maxLength) || languages[lang].defaultValidations.max + ' ' + maxLength + ' ' + languages[lang].defaultValidations.char;
    };
}

function minLength(minLength) {
    return value => {
        const lang = getCurrentLang();
        return (value && value.length >= minLength) || languages[lang].defaultValidations.min + ' ' + minLength + ' ' + languages[lang].defaultValidations.char;
    };
}

function hasPropertiesInObject(expectedProperties, object) {
    if (!Array.isArray(expectedProperties))
        throw new Error('validatePropertiesOfObject should receive an array with the properties to be validated');

    const objectKeys = Object.keys(object);
    return expectedProperties.every(key => objectKeys.indexOf(key) >= 0);
}

function hasPropertiesInObjectsOfArray(expectedProperties, array) {
    if (!Array.isArray(expectedProperties) || !Array.isArray(array))
        throw new Error(
            'hasPropertiesInObjectsOfArray should receive an array with the properties to be validated and the array to be iterated'
        );

    return array.every(object => {
        let objectKeys = Object.keys(object);
        return expectedProperties.every(key => objectKeys.indexOf(key) >= 0);
    });
}

// To Type Number Only - Function to reserve numbers only and exlucide (e, +, etc)
function onlyNumberRule(event) {
    if (event.which != 8 && event.which != 0 && event.which < 48 || event.which > 57) {
        event.preventDefault();
    };
}

function urlValidation(value) {
    const lang = getCurrentLang();
    const newRegex = /(https?:\/\/)([0-9a-zA-Z][-\w]*[0-9a-zA-Z]\.)+([a-zA-Z]{2,9})(:\d{1,4})?([-\w\/#~:.?+=&%@~]*)/.test(value)
    return newRegex || languages[lang].defaultValidations.url;
}

export { required, isEmail, maxLength, minLength, hasPropertiesInObject, hasPropertiesInObjectsOfArray, onlyNumberRule, urlValidation };
